import { render, staticRenderFns } from "./addresslist.vue?vue&type=template&id=4dd4a9f7&scoped=true&"
import script from "./addresslist.vue?vue&type=script&lang=js&"
export * from "./addresslist.vue?vue&type=script&lang=js&"
import style0 from "./addresslist.vue?vue&type=style&index=0&id=4dd4a9f7&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4a9f7",
  null
  
)

export default component.exports